import classNames from 'classnames';

import './FullScreen.scss';

export default ({ className, children }) => {
  return <div className={classNames('FullScreen', className)}>{children}</div>;
};
